export default __webpack_public_path__ + "static/media/banner2.1f192830.jpg";